export default __webpack_public_path__ + "static/media/caveat-v9-latin_cyrillic-regular.ba802fdd.woff2";